import Switch from "@imminently/decisively-ui/Switch";
import { usePreferences } from "../PreferencesContext";
import type { FeatureSettings } from "@/config/features";

type DeveloperKey = keyof FeatureSettings["developer"];

interface FeatureDef {
  key: DeveloperKey;
  label: string;
  description: string;
}

const FEATURES: FeatureDef[] = [
  {
    key: "debug",
    label: "Debug Mode",
    description: "Enable debug mode with additional logging and developer tools",
  },
  {
    key: "command_palette",
    label: "Command Palette",
    description: "Enable the command palette for quick commands and advanced searching across the platform",
  },
];

export const DeveloperPanel = () => {
  const { featureSettings, toggleFeature } = usePreferences();

  return (
    <div className="p-8 space-y-6 max-w-2xl">
      <div>
        <h2 className="text-2xl font-bold">Developer Features</h2>
        <p className="text-muted-foreground mt-1">Advanced features for developers and debugging</p>
      </div>

      <div className="space-y-2">
        {FEATURES.map((feature) => (
          <div
            key={feature.key}
            className="flex items-start justify-between px-4 py-4 rounded-lg border bg-card gap-4"
          >
            <div className="flex-1 min-w-0">
              <label
                htmlFor={`developer.${feature.key}`}
                className="block text-sm font-medium cursor-pointer mb-1"
              >
                {feature.label}
              </label>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </div>
            <Switch
              id={`developer.${feature.key}`}
              checked={featureSettings.developer[feature.key]}
              onCheckedChange={() => toggleFeature(`developer.${feature.key}`)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
